import { useTranslations } from '@vocab/react';
import { Alert, Box, Loader, Text } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import translations from '@seek/rr-caja/src/.vocab';

interface LoaderPanelProps {
  isLoading: boolean;
}

const LoaderPanel: FunctionComponent<LoaderPanelProps> = ({ isLoading }) => {
  const { t } = useTranslations(translations);

  return isLoading ? (
    <Box role="alert" aria-label="Loading questions">
      <Loader />
    </Box>
  ) : (
    <Alert>
      <Text>{t('questions.placeholder')}</Text>
    </Alert>
  );
};

LoaderPanel.displayName = 'LoaderPanel';

export default LoaderPanel;
